/* eslint no-unused-vars: "off" */
export default function slideReset(speed, runCallbacks, internal) {
  if (speed === void 0) {
    speed = this.params.speed;
  }

  if (runCallbacks === void 0) {
    runCallbacks = true;
  }

  var swiper = this;
  return swiper.slideTo(swiper.activeIndex, speed, runCallbacks, internal);
}


//////////////////
// WEBPACK FOOTER
// ./~/swiper/esm/components/core/slide/slideReset.js
// module id = 1180
// module chunks = 168